import { http } from '@/services';

export default {

  getQuestionList: ({ page, size, search }) => {
    return http.get('questao/', {
      params: {
        page: page, 
        size: size,
        search: search
      }
    });
  },

  getQuestionById: (questionId) =>{
      return http.get(`questao/${questionId}`)
  },
  
  createQuestion: async function(newQuestion) {
    try {
      return await http.post('questao/', newQuestion);
    } catch (e) {
      return e.response.data;
    }
  },
  editQuestion: async function(currentQuestion) {
    try {
      return await http.put('questao/', currentQuestion);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteQuestion: async function(questionId) {
    try {
      return await http.delete(`questao/${questionId}`);
    } catch (e) {
      console.log(e);
      return e.response.data;
    }
  },
};
